import { GridColDef } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import IconButton from '@/shared/components/IconButton/IconButton'
import ChipsCell from '@/shared/components/Table/components/ChipsCell/ChipsCell'
import styles from '../../MenuMangementColumns.module.scss'

export const useIngredientsColumnsConfig = (
  handleOnChange?: (id: string) => void,
  handleOnDelete?: (id: string) => void
) => {
  const { t } = useTranslation()
  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        resizable: false,
        width: 44,
        headerClassName: `${styles.tableHeader}`,
        cellClassName: styles.tableCell,
        sortable: false,
        hideSortIcons: true,
        disableColumnMenu: true,
        hideable: false,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        )
      },
      {
        field: 'name',
        headerName: t('TABLE.MENU.HEADERS.NAME'),
        editable: false,
        hideable: false,
        headerClassName: `${styles.tableHeader}`,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        flex: 1,
        minWidth: 128,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        )
      },
      {
        field: 'allergens',
        headerName: t('TABLE.MENU.HEADERS.ALLERGENS'),
        editable: false,
        headerClassName: `${styles.tableHeader}`,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        sortable: false,
        flex: 1,
        minWidth: 128,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        ),
        renderCell: params => <ChipsCell chipPayload={params.value} />
      },
      {
        field: 'quantity',
        headerName: t('TABLE.MENU.HEADERS.QUANTITY'),
        editable: false,
        headerClassName: `${styles.tableHeader}`,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        flex: 1,
        minWidth: 100,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        )
      },
      {
        field: 'unit',
        headerName: t('TABLE.MENU.HEADERS.UNIT'),
        editable: false,
        headerClassName: `${styles.tableHeader}`,
        cellClassName: styles.tableCell,
        disableColumnMenu: true,
        resizable: false,
        flex: 1,
        minWidth: 100,
        renderHeader: params => (
          <p className={`${styles.tableHeaderText} body-bold-medium`}>
            {params.colDef.headerName}
          </p>
        )
      },
      {
        field: 'action',
        resizable: false,
        editable: false,
        headerClassName: `${styles.tableHeader}`,
        cellClassName: `${styles.tableCell}`,
        disableColumnMenu: true,
        disableReorder: true,
        sortable: false,
        pinnable: true,
        hideable: false,
        width: 80,
        minWidth: 80,
        maxWidth: 80,
        renderHeader: params => (
          <p
            className={`${styles.tableHeaderText} body-bold-medium hideRightSeparator`}
          >
            {params.colDef.headerName}
          </p>
        ),
        renderCell: params => (
          <div className={`${styles.tableActionContainer}`}>
            <IconButton
              icon="las la-edit icon-medium"
              onClick={() => handleOnChange?.(params.row.id)}
              color="primary"
            />
            <IconButton
              icon="las la-trash icon-medium"
              onClick={() => handleOnDelete?.(params.row.id)}
              color="primary"
            />
          </div>
        )
      }
    ],
    [handleOnChange, handleOnDelete, t]
  )
  return columns
}
